// extracted by mini-css-extract-plugin
module.exports = {"input":"add-group_input_1cKjI","inputContainer":"add-group_inputContainer_1WwBP","label":"add-group_label_3jLGb"};